import { CLEAR_PATIENT_CASES, GET_PATIENT_CASES } from "../Cases/CasesActions";
import {
  ADD_ATHLETE,
  GET_AILING_ATHLETES,
  GET_ATHLETE_BY_ID,
  GET_ATHLETES_WITHOUT_PARAMS,
  GET_BODY_LOCATIONS,
  GET_CHRONIC_ATHLETES,
  GET_CLOSED_CASES,
  GET_HEALTHY_ATHLETES,
  GET_INJURED_ATHLETES,
  GET_OPEN_CASES,
  GET_RECOVERING_ATHLETES,
  PATIENT_IMAGE_ANALYSIS_STORE,
  PATIENT_QUESTION_ANSWER,
  PATIENT_SYMPTOM,
  SEARCH_PATIENTS,
  SEND_ENJURY_REPORT,
  SET_CLINICAL_SUMMARY,
  TOGGLE_PLAYING_STATUS,
  UPDATE_INJURY_REPORT,
  SET_VIKRUTI_DATA,
  BLOOD_REPORT_DATA,
  SET_VIKRUTI_AVERAGE_DATA,
  SET_SYMPTOMS_DATA,
} from "./PatientActions";

const initialState = {
  athletes: null,
  patients: [],
  athlete: null,
  cases: [],
  openCases: [],
  closedCases: [],
  injuredAthletes: [],
  recoveringAthletes: { rows: [], count: 0 },
  healthyAthletes: [],
  ailingAthletes: { rows: [], count: 0 },
  chronicAthletes: { rows: [], count: 0 },
  report: null,
  bodyLocations: null,
  injuryReport: null,
  patientSymptom: [],
  clinicalSummary: [],
  vikrutiData: null,
  bloodReportData: null,
  vikrutiAverageData: null,
  symptomsData: [],
};

/**
 * reducer function to update state based on action
 * @param state: current state of the reducer
 * @param action: action to perform on the data
 * @returns {({openCases: *[], healthyAthletes: *[], cases: *[], injuredAthletes: *[], ailingAthletes: *[], athlete: null, report: null, athletes: null, chronicAthletes: *[], recoveringAthletes: *[], closedCases: *[]} & {ailingAthletes: ([]|*)})|({openCases: *[], healthyAthletes: *[], cases: *[], injuredAthletes: *[], ailingAthletes: *[], athlete: null, report: null, athletes: null, chronicAthletes: *[], recoveringAthletes: *[], closedCases: *[]} & {chronicAthletes: ([]|*)})|{athlete: {playingStatus}}|{openCases: *[], healthyAthletes: *[], cases: *[], injuredAthletes: *[], ailingAthletes: *[], athlete: null, report: null, athletes: null, chronicAthletes: *[], recoveringAthletes: *[], closedCases: *[]}|({openCases: *[], healthyAthletes: *[], cases: *[], injuredAthletes: *[], ailingAthletes: *[], athlete: null, report: null, athletes: null, chronicAthletes: *[], recoveringAthletes: *[], closedCases: *[]} & {athletes: (null|[]|*)})|({openCases: *[], healthyAthletes: *[], cases: *[], injuredAthletes: *[], ailingAthletes: *[], athlete: null, report: null, athletes: null, chronicAthletes: *[], recoveringAthletes: *[], closedCases: *[]} & {openCases: ([]|*)})|({openCases: *[], healthyAthletes: *[], cases: *[], injuredAthletes: *[], ailingAthletes: *[], athlete: null, report: null, athletes: null, chronicAthletes: *[], recoveringAthletes: *[], closedCases: *[]} & {injuredAthletes: ([]|*)})|({openCases: *[], healthyAthletes: *[], cases: *[], injuredAthletes: *[], ailingAthletes: *[], athlete: null, report: null, athletes: null, chronicAthletes: *[], recoveringAthletes: *[], closedCases: *[]} & {athlete: (null|*)})|({openCases: *[], healthyAthletes: *[], cases: *[], injuredAthletes: *[], ailingAthletes: *[], athlete: null, report: null, athletes: null, chronicAthletes: *[], recoveringAthletes: *[], closedCases: *[]} & {closedCases: ([]|*)})|({openCases: *[], healthyAthletes: *[], cases: *[], injuredAthletes: *[], ailingAthletes: *[], athlete: null, report: null, athletes: null, chronicAthletes: *[], recoveringAthletes: *[], closedCases: *[]} & {healthyAthletes: ([]|*)})|({openCases: *[], healthyAthletes: *[], cases: *[], injuredAthletes: *[], ailingAthletes: *[], athlete: null, report: null, athletes: null, chronicAthletes: *[], recoveringAthletes: *[], closedCases: *[]} & {report: *})|({openCases: *[], healthyAthletes: *[], cases: *[], injuredAthletes: *[], ailingAthletes: *[], athlete: null, report: null, athletes: null, chronicAthletes: *[], recoveringAthletes: *[], closedCases: *[]} & {cases})|({openCases: *[], healthyAthletes: *[], cases: *[], injuredAthletes: *[], ailingAthletes: *[], athlete: null, report: null, athletes: null, chronicAthletes: *[], recoveringAthletes: *[], closedCases: *[]} & {recoveringAthletes: ([]|*)})}
 * @constructor
 */
const PatientReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ATHLETES_WITHOUT_PARAMS:
      return Object.assign({}, state, {
        athletes: action.athletes,
      });

    case GET_INJURED_ATHLETES:
      return Object.assign({}, state, {
        injuredAthletes: action.injuredAthletes,
      });

    case GET_RECOVERING_ATHLETES:
      return Object.assign({}, state, {
        recoveringAthletes: action.recoveringAthletes || { rows: [], count: 0 },
      });

    case GET_HEALTHY_ATHLETES:
      return Object.assign({}, state, {
        healthyAthletes: action.healthyAthletes || { rows: [], count: 0 },
      });
    case GET_AILING_ATHLETES:
      return Object.assign({}, state, {
        ailingAthletes: action.ailingAthletes || { rows: [], count: 0 },
      });
    case GET_CHRONIC_ATHLETES:
      return Object.assign({}, state, {
        chronicAthletes: action.chronicAthletes || { rows: [], count: 0 },
      });

    case ADD_ATHLETE:
      let newAthlete = action.athlete;
      let updatedAthletesCount = state.athletes.count + 1;
      let updatedAthletesRow = [newAthlete, ...state.athletes.rows];
      let updatedAthletes = {
        count: updatedAthletesCount,
        rows: updatedAthletesRow,
      };
      return {
        ...state,
        athlete: action.athlete,
        athletes: updatedAthletes,
      };

    case GET_ATHLETE_BY_ID:
      return Object.assign({}, state, {
        athlete: action.athlete,
      });

    case GET_PATIENT_CASES:
      return Object.assign({}, state, {
        cases: action.cases,
      });

    case CLEAR_PATIENT_CASES:
      return Object.assign({}, state, {
        cases: [],
      });

    case GET_OPEN_CASES:
      return Object.assign({}, state, {
        openCases: action.openCases,
      });

    case GET_CLOSED_CASES:
      return Object.assign({}, state, {
        closedCases: action.closedCases,
      });

    case TOGGLE_PLAYING_STATUS:
      return {
        athlete: {
          ...state.athlete,
          playingStatus: action.athlete.playingStatus,
        },
      };

    case SEND_ENJURY_REPORT:
      return Object.assign({}, state, {
        report: action.report,
      });

    case GET_BODY_LOCATIONS:
      return Object.assign({}, state, {
        bodyLocations: action.bodyLocations,
      });

    case UPDATE_INJURY_REPORT:
      return Object.assign({}, state, {
        injuryReport: action.injuryReport,
      });

    case SEARCH_PATIENTS:
      return {
        ...state,
        patients: action.payload,
      };
    case PATIENT_SYMPTOM:
      return {
        ...state,
        patientSymptom: action.payload,
      };
    case PATIENT_IMAGE_ANALYSIS_STORE:
      return {
        ...state,
        patientImageAnalysisStore: action.payload,
      };
    case PATIENT_QUESTION_ANSWER:
      return {
        ...state,
        patientQuestionAnswer: action.payload,
      };
    case SET_CLINICAL_SUMMARY:
      return {
        ...state,
        clinicalSummary: action.payload,
      };
    case SET_VIKRUTI_DATA:
      return {
        ...state,
        vikrutiData: action.payload,
      };
    case BLOOD_REPORT_DATA:
      return {
        ...state,
        bloodReportData: action.payload,
      };
    case SET_VIKRUTI_AVERAGE_DATA:
      return {
        ...state,
        vikrutiAverageData: action.payload,
      };

    case SET_SYMPTOMS_DATA:
      return {
        ...state,
        symptomsData: action.payload,
      };

    default:
      return state;
  }
};

export default PatientReducer;
